import React from "react";

const ClearAll = ({ handleClearAll }) => <span tabIndex="-1" aria-label="Clear All" onClick={ handleClearAll } className="clear-all link-underline"> Clear All </span>

export default ClearAll;